import { DealManagerDashboardComponent } from "@/features";

export const DMDashboardPage = () => {
  return <DealManagerDashboardComponent />;
}